import { apiAction, apiFetch, getMetaContent } from 'utils';
import DuckEntity from './DuckEntity';

const duck = new DuckEntity('disputes');

const update = ({disputeId, action, signatureFile, communicationFile, uncategorizedFile, uncategorizedText, submit}) => {
  let token = getMetaContent('csrf-token');

  const headers = { Accept: 'application/json', 'X-CSRF-Token': token };
  const data = new FormData();
  data.append('customer_signature', signatureFile);
  data.append('uncategorized_file', uncategorizedFile);
  data.append('customer_communication', communicationFile);
  data.append('uncategorized_text', uncategorizedText);
  data.append('dispute_action', action);
  data.append('submit', submit);

  const actionParams =  {dispute_action: action, submit: submit, evidence: {customer_communication: communicationFile, uncategorized_file: uncategorizedFile, uncategorized_text: uncategorizedText}}
  return apiAction(
    duck.actions.SAVE_BEGIN, duck.actions.SAVE_SUCCESS, duck.actions.SAVE_ERROR,
    (state) => apiFetch.put(state, duck.config.entityApiPath(disputeId), null, { rawBody: data, headers }),
    actionParams
  );
};

export const disputes = {
  ...duck,
  actions: {
    ...duck.actions,
    update
  }
};

export default disputes.reducer;
